import type { NavItem } from '@/app/nav/collect'

/**
 * The legacy Tasks menus — the "Tasks" group (Tasks, Task templates, Task groups) of the employer softwares and
 * Accounting, and the single "Tasks" entry of the `ca` / `em` Freelancer navs (wp/tasks §1.2, §3) — are declared once by
 * the shell (`src/modules/shell/nav.ts`, ids `tasks*`, `ca-tasks`, `em-tasks`) and already point at this module's
 * paths. Legacy had no other tasks entry, so the module adds none.
 */
const nav: NavItem[] = []

export default nav
